/**
 * lp-sofa-check: ビーズソファ メンテナンス提案LP
 * 設問の状態管理・スライドアニメーション・戻るボタン
 */
(function () {
  'use strict';

  /* 導入スライドをスキップし、商品選択を1枚目にする（true: スキップ / false: 導入あり） */
  var SKIP_INTRO = true;

  /* スライド index: 0=導入, 1-5=設問, 6-10=結果A-E */
  var STEP_RESULT_A = 6;
  var STEP_RESULT_B = 7;
  var STEP_RESULT_C = 8;
  var STEP_RESULT_D = 9;
  var STEP_RESULT_E = 10;
  var BASE_BEADS = '/products/beads';
  var BASE_PRO_BEADS = '/products/pro-beads';
  var VARIANT_ID_BY_GRAMS = {
    standard: {
      750: '49736386183484',
      1500: '52278403760444',
      3000: '52278405136700'
    },
    premium: {
      750: '49736385888572',
      1500: '52278409494844',
      3000: '52278410772796'
    }
  };

  function getConfig(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return null;
    var script = document.getElementById('lp-sofa-check-config-' + sectionId);
    if (!script || script.textContent === '') return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findSlides(root) {
    return root.querySelectorAll('.lp-sofa-check__slide');
  }

  function getSlideIndex(slides, dataStep) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-step') === String(dataStep)) return i;
    }
    return -1;
  }

  function applySlidePosition(slidesEl, index) {
    /* 各スライドは親幅の100%なので、1スライド分 = -100% */
    var percent = index * 100;
    slidesEl.style.transform = 'translateX(-' + percent + '%)';
  }

  function setSlideVisibility(slides, currentIndex) {
    slides.forEach(function (slide, i) {
      var hidden = i !== currentIndex;
      slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });
  }

  function setBackButtonState(buttons, slides, currentIndex) {
    buttons.forEach(function (btn) {
      var slide = btn.closest('.lp-sofa-check__slide');
      var index = Array.prototype.indexOf.call(slides, slide);
      var isCurrent = index === currentIndex;
      btn.disabled = currentIndex <= 0 || (SKIP_INTRO && currentIndex === 1) || !isCurrent;
    });
  }

  function setResultLink(config, answers, root) {
    if (!config || !config.products) return;
    var productKey = answers[0];
    var beadType = answers[1]; /* 'standard' | 'premium' (2問目) */
    var condition = answers[4]; /* 'good' | 'soso' | 'bad' */

    var linkA = root.querySelector('.lp-sofa-check__result-link[data-result="a"]');
    var linkB = root.querySelector('.lp-sofa-check__result-link[data-result="b"]');
    var linkC1 = root.querySelector('.lp-sofa-check__result-link[data-result="c1"]');
    var linkC2 = root.querySelector('.lp-sofa-check__result-link[data-result="c2"]');
    var linkD1 = root.querySelector('.lp-sofa-check__result-link[data-result="d1"]');
    var linkD2 = root.querySelector('.lp-sofa-check__result-link[data-result="d2"]');
    var linkE1 = root.querySelector('.lp-sofa-check__result-link[data-result="e1"]');
    var linkE2 = root.querySelector('.lp-sofa-check__result-link[data-result="e2"]');
    var gramsTextC = root.querySelector('.lp-sofa-check__result-grams[data-result-grams="c"]');
    var gramsTextD = root.querySelector('.lp-sofa-check__result-grams[data-result-grams="d"]');
    var gramsTextE = root.querySelector('.lp-sofa-check__result-grams[data-result-grams="e"]');

    var product = config.products.find(function (p) { return p.key === productKey; });
    var standard = beadType === 'standard';
    var hrefA = product ? ((standard ? product.pageAStandard : product.pageAPremium) || '#') : '#';
    var hrefB = product ? ((standard ? product.pageBStandard : product.pageBPremium) || '#') : '#';
    if (linkA) linkA.href = hrefA;
    if (linkB) linkB.href = hrefB;

    var gramsC = product && (standard ? product.pageCVariantStandard : product.pageCVariantPremium);
    var gramsD = product && (standard ? product.pageDVariantStandard : product.pageDVariantPremium);
    var gramsE = product && (standard ? product.pageEVariantStandard : product.pageEVariantPremium);
    var variantIds = standard ? VARIANT_ID_BY_GRAMS.standard : VARIANT_ID_BY_GRAMS.premium;
    var baseBeads = standard ? BASE_BEADS : BASE_PRO_BEADS;
    var variantC = gramsC && variantIds[Number(gramsC)];
    var variantD = gramsD && variantIds[Number(gramsD)];
    var variantE = gramsE && variantIds[Number(gramsE)];

    if (linkC1) linkC1.href = hrefA;
    if (linkC2) linkC2.href = variantC ? baseBeads + '?variant=' + variantC : '#';
    if (linkD1) linkD1.href = hrefA;
    if (linkD2) linkD2.href = variantD ? baseBeads + '?variant=' + variantD : '#';
    if (linkE1) linkE1.href = hrefB;
    if (linkE2) linkE2.href = variantE ? baseBeads + '?variant=' + variantE : '#';

    function setGramsText(el, grams) {
      if (!el) return;
      var g = Number(grams);
      el.textContent = g ? g + 'g' : '';
    }

    setGramsText(gramsTextC, gramsC);
    setGramsText(gramsTextD, gramsD);
    setGramsText(gramsTextE, gramsE);
  }

  function getNextStep(currentStep, answers, choiceValue) {
    /* currentStep = スライド index（1-5 が設問） */
    if (currentStep === 1) return 2; /* 商品 → ビーズ種類 */
    if (currentStep === 2) return 3; /* ビーズ種類 → カバー */
    if (currentStep === 3) return choiceValue === 'yes' ? STEP_RESULT_A : 4; /* カバー Yes→A, No→インナー */
    if (currentStep === 4) return choiceValue === 'yes' ? STEP_RESULT_B : 5; /* インナー Yes→B, No→状態 */
    if (currentStep === 5) {
      if (choiceValue === 'good') return STEP_RESULT_C;
      if (choiceValue === 'soso') return STEP_RESULT_D;
      if (choiceValue === 'bad') return STEP_RESULT_E;
    }
    return currentStep;
  }

  function init(root) {
    var config = getConfig(root);
    var slidesEl = root.querySelector('.lp-sofa-check__slides');
    var backButtons = root.querySelectorAll('.lp-sofa-check__back-btn');
    if (!slidesEl || backButtons.length === 0) return;

    var slides = findSlides(root);
    if (slides.length === 0) return;

    var state = {
      currentIndex: 0,
      answers: [],
      stepHistory: []
    };

    function goToStep(index) {
      state.currentIndex = index;
      applySlidePosition(slidesEl, index);
      setSlideVisibility(slides, index);
      setBackButtonState(backButtons, slides, index);

      if (index >= STEP_RESULT_A && index <= STEP_RESULT_E) {
        setResultLink(config, state.answers, root);
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function onChoiceClick(e) {
      /* 開始ボタン: 導入 → 設問1 */
      var startBtn = e.target.closest('.lp-sofa-check__start-btn');
      if (startBtn) {
        state.stepHistory.push(0);
        goToStep(1);
        return;
      }

      var btn = e.target.closest('.lp-sofa-check__choice-btn');
      if (!btn) return;
      var value = btn.getAttribute('data-value');
      var step = parseInt(btn.getAttribute('data-step'), 10);
      if (value === '' || isNaN(step)) return;

      /* 設問スライドは index 1-5。answers の index は 0-4 */
      if (state.currentIndex < 1 || state.currentIndex > 5) return;

      /* クリックされた選択肢を active にする（同一スライド内で排他） */
      var currentSlide = btn.closest('.lp-sofa-check__slide');
      if (currentSlide) {
        var choiceBtns = currentSlide.querySelectorAll('.lp-sofa-check__choice-btn');
        choiceBtns.forEach(function (b) {
          b.classList.remove('active');
        });
      }
      btn.classList.add('active');

      state.answers[step] = value;
      state.stepHistory.push(state.currentIndex);
      var next = getNextStep(state.currentIndex, state.answers, value);
      goToStep(next);
    }

    function onBackClick() {
      if (state.currentIndex <= 0) return;
      if (SKIP_INTRO && state.currentIndex === 1) return;
      var prev = state.stepHistory.length > 0 ? state.stepHistory.pop() : state.currentIndex - 1;
      if (prev < 0) prev = 0;
      goToStep(prev);
    }

    slidesEl.addEventListener('click', onChoiceClick);
    backButtons.forEach(function (btn) {
      btn.addEventListener('click', onBackClick);
    });

    var startIndex = SKIP_INTRO ? 1 : 0;
    state.currentIndex = startIndex;
    applySlidePosition(slidesEl, startIndex);
    setSlideVisibility(slides, startIndex);
    setBackButtonState(backButtons, slides, startIndex);
  }

  function bootstrap() {
    var roots = document.querySelectorAll('#lp-sofa-check[data-section-id]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
